import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios/index';

import SpogModal from 'components/ui/layout/panel/SpogModal';

class CheckVersion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.checkVersion();
    }

    checkVersion() {
        axios.get(require('version'))
            .then(() => setTimeout(() => this.checkVersion(), 60 * 1000))
            .catch(() => this.setState({showModal: true}));
    }

    render() {
        const {intl: {formatMessage}} = this.props;

        return (
            <SpogModal
                showModal={this.state.showModal}
                title={formatMessage({id: 'title.modal.checkVersion'})}
                closeText={formatMessage({id: 'text.modal.checkVersion.accept'})}
                onClose={() => window.location.reload()}
                onAccept={() => window.location.reload()}
            >
                <p>{formatMessage({id: 'description.modal.checkVersion'})}</p>
            </SpogModal>
        );
    }
}

export default injectIntl(CheckVersion);



// WEBPACK FOOTER //
// ./src/components/check-version/CheckVersion.jsx